import { __decorate, __metadata } from "tslib";
import _ from 'lodash';
import { Component, Ref, Watch, Mixins, Inject } from 'vue-property-decorator';
import Tooltip from 'element-ui/lib/tooltip';
import JSEncrypt from 'jsencrypt';
import { getVar, postVar, getAllVarsForLogin } from 'library-components/utils/environment';
import PtIcon from '@patsnap-biz/icon';
import { E_Switch } from 'library-components/apis/passport/passport.type';
import { E_LoginMethod } from 'library-components/apis/login/login.type';
import { getPublicKeyApi, loginSubmitApi, mobileLoginApi, mobileLoginRegisterApi, postLoginVerifyCode } from 'library-components/apis/login/login';
import { setUserAccount, getUserAccount, setUserAccountMobileNumber, removeMobileVerifyCodeCountDownTime, setLoginTabTag, getUserAccountMobileNumber, setAccountPassWordKeepLoginStatus, getAccountPassWordKeepLoginStatus, setAccountSMSKeepLoginStatus, getAccountSMSKeepLoginStatus, } from 'library-components/services/localStorage';
import { applyAuthInterceptor } from 'library-components/config/authInterceptor';
import { RavenInsertMeta, PendoInsertMeta } from 'library-components/services/sentry';
import { click_direct_login } from 'library-components/config/eventNames/eventNames';
import { anonymousLoginCheckSession } from 'library-components/config/token-base';
import { setEnterLoginCookie } from 'library-components/services/cookie';
import { registerUrlParamKeys } from 'library-components/apis/register/register.type';
import PsInput from 'library-components/components/Input/Input.vue';
import { emailRe, phoneCodeNumberRe, separatorRe } from 'library-components/utils/regex';
import { E_MobileVerifyCodePurpose } from 'library-components/apis/passport/types';
import MobileVerifyCodeForm from 'library-components/components/MobileVerifyCodeForm/MobileVerifyCodeForm.vue';
import { CLOSE } from 'library-components/apis/passport/error';
import { ReCaptchaVerificationMixin } from 'library-components/mixins/reCaptchaVerificationMixin';
import WechatCode from '../WechatLogin/WechatCode.vue';
import '@patsnap-ui/icon/assets/solid/wechat.svg';
import PtPopper from '@patsnap-biz/popper';
import '@patsnap-biz/popper/lib/style';
import { validateLoginPwd } from 'library-components/utils/validator';
import 'tippy.js/dist/border.css';
import { E_PRODUCTS_NAME, INCITATION_CODE_TYPE } from 'library-components/apis/type';
import GoogleLoginButton from '../GoogleLogin/GoogleLoginButton/GoogleLoginButton.vue';
import '@patsnap-biz/design-tokens/scss/_tooltip.scss';
import TermsOfServiceUpdate from 'library-components/components/TermsOfServiceUpdate/TermsOfServiceUpdate.vue';
import { E_ConfirmResult } from 'library-components/utils/task';
import { jumpTo } from '@/infrastructure/utils/jump';
import { MultiTenantSelectService } from '@/services/multiTenantSelectService';
import { TrialTermsMsgBoxService } from '@/services/trialTermsMsgBoxService';
import SSOLogin from '../SSOLogin/SSOLogin.vue';
import { OFFICIAL_URL } from 'library-components/constant/urls';
function makePasswordForm() {
    const email = getVar('account') || getUserAccount();
    const keeplogin = getAccountPassWordKeepLoginStatus() === 'true';
    return {
        email,
        password: '',
        keeplogin,
    };
}
function makeSmsForm(locale, isFromFreemium) {
    const mobile_number = getUserAccountMobileNumber(isFromFreemium ? E_MobileVerifyCodePurpose.LOGIN_REGISTER : E_MobileVerifyCodePurpose.LOGIN);
    const keeplogin = getAccountSMSKeepLoginStatus() === 'true';
    return {
        mobile_number,
        verify_code: '',
        keeplogin,
        purpose: isFromFreemium ? E_MobileVerifyCodePurpose.LOGIN_REGISTER : E_MobileVerifyCodePurpose.LOGIN,
        country_code: '',
    };
}
let LoginTabImpl = class LoginTabImpl extends Mixins(ReCaptchaVerificationMixin) {
    constructor() {
        super(...arguments);
        this.E_LoginMethod = E_LoginMethod;
        this.activeTabName = this.commonService.DefaultLoginMethod;
        this.isLoading = false;
        this.carciLoginVisible = false;
        this.formPassword = makePasswordForm();
        this.multiTenantSelectService = new MultiTenantSelectService({
            selector: '.login-panel-body__content',
            i18n: this.$i18n,
        });
        this.trialTermsMsgBoxService = new TrialTermsMsgBoxService({
            selector: '.login-panel-body__content',
            i18n: this.$i18n,
        });
        // 是否进行极验
        this.isNeedCaptcha = false;
        this.formSms = makeSmsForm(this.$i18n.locale, this.commonService.IsFromFreemium);
        this.emailVerifyDialog = {
            visible: false,
            loginData: {},
            domains: [],
        };
        this.tippyJsPwdErrorInstance = null;
        this.capsLock = false;
    }
    onActiveNameChange(tabName) {
        setLoginTabTag(this.activeTabName);
    }
    onKeepLoginChange() {
        const status = _.toString(this.formPassword.keeplogin);
        setAccountPassWordKeepLoginStatus(status);
    }
    onSmsKeepLoginChange() {
        const status = _.toString(this.formSms.keeplogin);
        setAccountSMSKeepLoginStatus(status);
    }
    onDefaultLoginMethodChange() {
        this.activeTabName = this.commonService.DefaultLoginMethod;
    }
    /**
     * 企业用户自注册
     */
    get CanRegistrationForCustomers() {
        return this.commonService.AllowRegiser;
    }
    /**
     * 免费注册
     */
    get CanRegistrationForFree() {
        return !this.commonService.AllowRegiser && !this.commonService.AnonymousLogin && this.NoAccountRegisterUrl;
    }
    /**
     * 直接接入
     */
    get CanEntry() {
        return this.commonService.AnonymousLogin && !this.commonService.IsFromEureka;
    }
    /**
     * 临时的特殊逻辑
     * huawei不需要匿名登录，引导免费注册
     */
    get AnonymousLoginForbidden() {
        return this.commonService.globalData?.anonymous_login_forbidden;
    }
    get paramsUrl() {
        const params = getAllVarsForLogin(['from', 'redirect_uri', 'client_id', ...registerUrlParamKeys]);
        return postVar({ ...params, page_email: this.formPassword.email });
    }
    // #region Urls
    get ForgetUrl() {
        return `${this.commonService.AccountHost}/public/?${this.paramsUrl}#/forgetPasswordEmail`;
    }
    get AccountForgetUrl() {
        return `${this.commonService.AccountHost}/public/?${this.paramsUrl}#/forgetPassword`;
    }
    get RegistrationForCustomersUrl() {
        const paramsStr = this.paramsUrl || '';
        const url = `${this.commonService.AccountHost}/public/?${paramsStr}#/register`;
        return url;
    }
    get NoAccountRegisterUrl() {
        const from = _.get(this.commonService, 'from');
        const yunChuangHost = this.commonService.YunChuangHost;
        if (from === E_PRODUCTS_NAME.yunchuang && yunChuangHost) {
            return `${yunChuangHost}/register`;
        }
        const accountHost = this.commonService.AccountHost;
        if ((this.commonService.IsFromFreemium || this.commonService.CanEurekaFreeRegister)) {
            if (!this.commonService.IsRegionCN) {
                return `${accountHost}/public/?${this.paramsUrl}#/registerForFree`;
            }
            // 用于触发免费产品的微信注册
            if (this.commonService.CanWechatLogin) {
                return `${accountHost}/?${this.paramsUrl}&c_type=${INCITATION_CODE_TYPE.FREE}`;
            }
        }
        if (!this.commonService.IsRegionCN)
            return;
        return OFFICIAL_URL;
    }
    /**
     * 企业付费注册url or 试用注册url or 免费注册url
     */
    get SigupUrl() {
        if (this.CanRegistrationForCustomers) {
            return this.RegistrationForCustomersUrl;
        }
        if (this.CanRegistrationForFree) {
            return this.NoAccountRegisterUrl;
        }
    }
    /** ****** 埋点相关 *********/
    get trackSuffix() {
        return this.commonService.CompanyName ? ' (Organization)' : '';
    }
    logRegist() {
        PendoInsertMeta('Register', `Clicked To Register${this.trackSuffix}`);
    }
    onActiveTabNameChange(tab) {
        PendoInsertMeta('Login', `Chosen Login Method (${tab})`);
    }
    onCarciLoginVisibleChange(bool) {
        if (bool) {
            PendoInsertMeta('Login', `Clicked To SSO Login${this.trackSuffix}`);
        }
    }
    /** ****** 埋点相关结束 *******/
    get WechatRegisterIconVisible() {
        return this.commonService.IsRegionCN && (this.commonService.IsFromFreemium || this.commonService.CanEurekaFreeRegister) && this.commonService.CanWechatLogin;
    }
    get showGoogleLogin() {
        return this.commonService.IsShowGoogleLogin;
    }
    /**
     * 跳转 强密码的 重置密码页
     */
    getResetPasswordUrl(params, loginType) {
        const accountHost = this.commonService.AccountHost;
        const { keeplogin } = this.formPassword;
        const resetPasswordUrlQueries = {
            remember_me: keeplogin ? E_Switch.On : E_Switch.Off,
            token: params.token,
            strongPwd: params.strong_password_need,
        };
        if (loginType === E_LoginMethod.password) {
            resetPasswordUrlQueries.email = params.username;
        }
        if (loginType === E_LoginMethod.mobilePassword) {
            resetPasswordUrlQueries.mobile_number = params.mobile_number;
        }
        return `${accountHost}/public/?${postVar(this.paramsUrl)}#/resetPassword?${postVar(resetPasswordUrlQueries)}`;
    }
    get freeRegisterUrl() {
        const accountHost = this.commonService.AccountHost;
        return `${accountHost}/public/?${this.paramsUrl}#/registerTrial`;
    }
    get AnonymousLogin() {
        return _.get(this.commonService, 'globalData.allow_anonymous_login', false);
    }
    get freemiumRegisterLegalMessage() {
        const showFreeRegisterLegalInfo = this.commonService.IsRegionCN && this.activeTabName === E_LoginMethod.sms && this.commonService.IsFromFreemium;
        if (showFreeRegisterLegalInfo) {
            const { official_privacy_url, official_trial_terms_url, } = _.get(this.commonService, 'globalData');
            const message = this.$t('passport.login_register_terms', {
                policyUrl: official_privacy_url,
                legalTrailUrl: official_trial_terms_url,
            });
            return message;
        }
    }
    get PasswordRules() {
        return {
            email: [
                { required: true, trigger: 'click' }
            ],
            password: [
                { required: true, trigger: 'click' }
            ],
        };
    }
    onEmailKeyupEnter() {
        if (this.formPassword.email) {
            this.passwordRef.focus();
        }
    }
    onPasswordKeyupEnter() {
        return this.loginSubmit();
    }
    async enterLogin() {
        const token = await anonymousLoginCheckSession({
            clientId: this.commonService.client_id,
        });
        if (token) {
            setEnterLoginCookie();
            applyAuthInterceptor(token);
            RavenInsertMeta('Login', click_direct_login);
            setTimeout(() => {
                this.onLoginSuccess({
                    isDirectLogin: true,
                });
            }, 100);
        }
    }
    trialTermsMsgBox(terms_update = false) {
        return this.trialTermsMsgBoxService.init(terms_update, {
            privacyPolicy: this.commonService.PrivacyPolicy,
            termsOfService: this.commonService.TermsOfService,
        });
    }
    async beforeLoginCheck(params, loginType) {
        this.isNeedCaptcha = false;
        this.multiTenantSelectService.beforeSelectTenant = () => {
            this.isLoading = false;
        };
        const tenantResult = await this.multiTenantSelectService.init(params, loginType);
        if (!tenantResult || tenantResult === E_ConfirmResult.CANCEL) {
            return;
        }
        this.isLoading = true;
        const multiData = await this.loginService.getPreLoginData(params, loginType);
        this.isNeedCaptcha = multiData.need_captcha;
        if (multiData) {
            const { exceeded, trial_terms, company_limited, token, strong_password_need, terms_update, } = multiData;
            if (trial_terms || terms_update) {
                // terms_update 为true trial_terms为false才弹最新条款
                const res = await this.trialTermsMsgBox(terms_update && !trial_terms);
                if (res !== E_ConfirmResult.CONFIRM) {
                    return;
                }
            }
            if (exceeded) {
                let message = this.$t('passport.logined_in_other_place');
                if (company_limited) {
                    message = this.$t('passport.maximum_company_logins_reached');
                }
                const res = await this.$msgbox({
                    message,
                    showCancelButton: true,
                    cancelButtonClass: 'patsnap-el-cancel',
                    confirmButtonClass: 'patsnap-el-confirm',
                    confirmButtonText: this.$t('passport.common.agree'),
                    cancelButtonText: this.$t('passport.common.cancel'),
                    closeOnClickModal: false,
                    showClose: false,
                }).catch((e) => {
                    return e;
                });
                if (res !== 'confirm') {
                    return;
                }
            }
            if (token) {
                const href = this.loginService.getResetPasswordUrl({
                    ...params,
                    token,
                    strong_password_need,
                    tenant_id: this.multiTenantSelectService.TenantId,
                }, loginType);
                jumpTo(href);
                return;
            }
            return true;
        }
    }
    getMobileLoginData({ username, country_code = '', mobile_number = '', ...otherData }) {
        const defaultCountryCode = this.commonService.DefaultCountryCode;
        if (!country_code) {
            if (_.startsWith(username, defaultCountryCode)) {
                country_code = defaultCountryCode;
                mobile_number = username.replace(country_code, '');
            }
            else {
                mobile_number = username;
            }
        }
        return { country_code: defaultCountryCode, mobile_number, ...otherData };
    }
    async loginSubmit(mobileLoginData = {}) {
        if (this.isLoading)
            return;
        this.$emit('reset');
        this.formPasswordRef.validate(async (valid) => {
            if (!valid) {
                return;
            }
            let { email, password, keeplogin } = this.formPassword;
            email = _.trim(email);
            password = _.trim(password);
            if (!email || !password) {
                this.onPassportError({
                    errcode: 30101,
                });
                return;
            }
            setUserAccount(email);
            const isEmailLogin = emailRe.test(email);
            const isMobileNumberLogin = phoneCodeNumberRe.test(email);
            if (!isEmailLogin && !isMobileNumberLogin) {
                this.onPassportError({
                    errcode: 30103.2,
                });
                return;
            }
            PendoInsertMeta('Login', isEmailLogin ? 'Email Password Login' : 'Mobile Password Login');
            let loginBaseData = {};
            let loginData = {};
            this.isLoading = true;
            try {
                const publicKey = await getPublicKeyApi();
                const encrypt = new JSEncrypt({});
                encrypt.setPublicKey(publicKey);
                const encryptPwd = encrypt.encrypt(password);
                loginBaseData = {
                    username: email,
                    password: encryptPwd,
                };
                if (!isEmailLogin) {
                    loginBaseData = this.getMobileLoginData(loginBaseData);
                }
                const preLoginParams = {
                    ...loginBaseData,
                    client_id: _.get(this.commonService, 'client_id'),
                    authc_type: 'ACCOUNT_PASSWORD',
                };
                const checkStatus = await this.beforeLoginCheck(preLoginParams, isEmailLogin ? E_LoginMethod.password : E_LoginMethod.mobilePassword);
                if (!checkStatus)
                    return;
                let resGeetestValidate = {};
                if (this.isNeedCaptcha) {
                    resGeetestValidate = await this.geetestValidate();
                    if (resGeetestValidate === CLOSE) {
                        return;
                    }
                }
                loginData = {
                    ...loginBaseData,
                    remember_me: keeplogin ? E_Switch.On : E_Switch.Off,
                    client_id: _.get(this.commonService, 'client_id'),
                    from: _.get(this.commonService, 'from'),
                    response_type: 'TOKEN',
                };
                const tokenRes = isEmailLogin ? await loginSubmitApi(loginData, resGeetestValidate) : await mobileLoginApi({ ...loginData, ...mobileLoginData }, resGeetestValidate);
                if (tokenRes.token) {
                    applyAuthInterceptor(tokenRes.token);
                    await this.onLoginSuccess();
                }
            }
            catch (e) {
                let errorCode = _.get(e, 'response.data.errcode') || _.get(e, 'response.data.numeric_error_code');
                const loginUrl = _.get(e, 'response.data.loginurl');
                const status = _.get(e, 'response.status');
                if (status === 500) {
                    // 服务器错误直接-1
                    // passport服务错误中也有 `number_error_code`
                    errorCode = -1;
                }
                if (errorCode === 30169) {
                    this.emailVerifyDialog.visible = true;
                    const { username, ...otherData } = loginData;
                    if (isEmailLogin) {
                        otherData.email = username;
                    }
                    this.emailVerifyDialog.loginData = otherData;
                    this.emailVerifyDialog.domains = this.getDomains(_.get(e, 'response.data.message_vars', [])?.[0]);
                    return;
                }
                // 手机登录 Invalid 或 用户账号被锁定
                if (!isEmailLogin) {
                    // 提示用户使用短信登录。
                    errorCode === 30116 && (errorCode = 30116.1);
                    if (errorCode === 30103 || errorCode === 30101) {
                        errorCode = 30103.1;
                    }
                }
                // 缓存
                if (errorCode === 30122 || errorCode === 30116.1) {
                    setUserAccountMobileNumber(loginBaseData.mobile_number, this.formSms.purpose);
                }
                if (errorCode) {
                    this.onPassportError({
                        errcode: errorCode,
                        email,
                        loginUrl,
                    });
                }
            }
            finally {
                this.isLoading = false;
            }
        });
    }
    goToForgetPassword() {
        const url = phoneCodeNumberRe.test(this.formPassword.email) && this.commonService.IsRegionCN ? this.AccountForgetUrl : this.ForgetUrl;
        jumpTo(url);
    }
    get SmsFormPurpose() {
        return this.commonService.IsFromFreemium ? E_MobileVerifyCodePurpose.LOGIN_REGISTER : E_MobileVerifyCodePurpose.LOGIN;
    }
    formSmsRefSubmit() {
        PendoInsertMeta('Login', 'Mobile Verify Code Login');
        this.$emit('reset');
        this.formSmsRef.submit();
    }
    smsLoginSubmitFail() {
        this.isLoading = false;
    }
    async smsLoginSubmit(data, needLoginCheck = true) {
        const { keeplogin, } = this.formSms;
        this.formSms.purpose = this.SmsFormPurpose;
        let loginData = {};
        if (this.isLoading && needLoginCheck)
            return;
        try {
            if (needLoginCheck) {
                const preLoginParams = {
                    client_id: _.get(this.commonService, 'client_id'),
                    from_freemium: this.commonService.IsFromFreemium,
                    ...data,
                };
                const checkStatus = await this.beforeLoginCheck(preLoginParams, E_LoginMethod.sms);
                if (!checkStatus)
                    return;
            }
            const urlParams = getAllVarsForLogin(['from', 'redirect_uri', 'client_id', ...registerUrlParamKeys]);
            loginData = {
                ...data,
                remember_me: keeplogin ? E_Switch.On : E_Switch.Off,
                client_id: _.get(this.commonService, 'client_id'),
                from: _.get(this.commonService, 'from'),
                response_type: 'TOKEN',
            };
            let tokenRes;
            if (this.commonService.IsFromFreemium) {
                tokenRes = await mobileLoginRegisterApi({
                    from: _.get(this.commonService, 'from'),
                    verify_code: data.verify_code,
                    remember_me: Boolean(keeplogin),
                }, {
                    mobile_number: data.mobile_number,
                    country_code: data.country_code,
                    response_type: 'TOKEN',
                    client_id: _.get(this.commonService, 'client_id'),
                    ...urlParams,
                });
            }
            else {
                tokenRes = await postLoginVerifyCode(loginData);
            }
            removeMobileVerifyCodeCountDownTime(this.formSms.purpose);
            if (tokenRes.token) {
                applyAuthInterceptor(tokenRes.token);
                await this.onLoginSuccess();
            }
        }
        catch (e) {
            let errorCode = _.get(e, 'response.data.errcode') || _.get(e, 'response.data.numeric_error_code');
            const status = _.get(e, 'response.status');
            const loginUrl = _.get(e, 'response.data.loginurl');
            if (status === 500) {
                // 服务器错误直接-1
                // passport服务错误中也有 `number_error_code`
                errorCode = -1;
            }
            if (errorCode === 30169) {
                this.emailVerifyDialog.visible = true;
                this.emailVerifyDialog.loginData = loginData;
                this.emailVerifyDialog.domains = this.getDomains(_.get(e, 'response.data.message_vars', [])?.[0]);
                return;
            }
            if (errorCode === 30101 && this.commonService.IsFromFreemium) {
                // 账号不存在，第一次登录 提示法律条款
                const res = await this.trialTermsMsgBox();
                if (res !== E_ConfirmResult.CONFIRM) {
                    return;
                }
                this.smsLoginSubmit(data, false);
                return;
            }
            errorCode === 30101 && (errorCode = 30101.1);
            errorCode === 30103 && (errorCode = 30103.1);
            if (errorCode) {
                this.onPassportError({
                    errcode: errorCode,
                    loginUrl,
                });
            }
        }
        finally {
            this.isLoading = false;
        }
    }
    getDomains(str = '') {
        const domains = [];
        const domainsAry = str.split(separatorRe);
        for (let i = 0; i < domainsAry.length; i++) {
            const email = _.trim(domainsAry[i]);
            if (email === '') {
                continue;
            }
            domains.push(`@${email}`);
        }
        return domains;
    }
    onCloseEmailVerifyDialog() {
        this.emailVerifyDialog.visible = false;
    }
    onIdentifyError(error) {
        if (error) {
            this.onPassportError(error);
        }
    }
    onPassportError(data) {
        if (data) {
            this.$emit('passport-error', {
                ...data,
            });
        }
    }
    async created() {
        if (!_.isNil(getVar('email'))) {
            this.formPassword.email = getVar('email');
        }
        PendoInsertMeta('Login', `Visited Login Page${this.trackSuffix}`);
    }
    get ValidateLoginPwd() {
        return validateLoginPwd(this, this.formPassword.password);
    }
    onPasswordInputChange() {
        this.tippyJsPwdErrorInstanceToggle();
    }
    tippyJsPwdErrorInstanceToggle() {
        this.initPwdPopper();
        if (this.ValidateLoginPwd) {
            this.tippyJsPwdErrorInstance[0].setContent(this.ValidateLoginPwd);
            this.tippyJsPwdErrorInstance[0].show();
            return;
        }
        if (this.capsLock) {
            this.tippyJsPwdErrorInstance[0].setContent(this.$t('passport.capslockTurnedOn'));
            this.tippyJsPwdErrorInstance[0].show();
            return;
        }
        this.tippyJsPwdErrorInstance[0].hide();
    }
    onPasswordKeyup(e) {
        // const keyCode = e.keyCode || e.which
        if (e.getModifierState) {
            if (e.getModifierState('CapsLock') && !e.shiftKey) {
                this.capsLock = true;
            }
            else {
                this.capsLock = false;
            }
            this.tippyJsPwdErrorInstanceToggle();
        }
    }
    initPwdPopper() {
        if (this.tippyJsPwdErrorInstance) {
            return;
        }
        this.tippyJsPwdErrorInstance = PtPopper.tippy('.login-panel-body__password-form-item', {
            trigger: 'manual',
            content: this.$t('passport.pwdEnterInvalidCharacters'),
            theme: 'warning',
            placement: 'bottom-start',
            zIndex: 100,
            delay: 150,
            appendTo: () => document.body,
        });
    }
    onLoginSuccess(opt) {
        return this.loginService.loginSuccess(opt);
    }
};
__decorate([
    Inject('loginService'),
    __metadata("design:type", Object)
], LoginTabImpl.prototype, "loginService", void 0);
__decorate([
    Watch('activeTabName'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LoginTabImpl.prototype, "onActiveNameChange", null);
__decorate([
    Watch('formPassword.keeplogin'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LoginTabImpl.prototype, "onKeepLoginChange", null);
__decorate([
    Watch('formSms.keeplogin'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LoginTabImpl.prototype, "onSmsKeepLoginChange", null);
__decorate([
    Watch('commonService.DefaultLoginMethod'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LoginTabImpl.prototype, "onDefaultLoginMethodChange", null);
__decorate([
    Watch('activeTabName'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LoginTabImpl.prototype, "onActiveTabNameChange", null);
__decorate([
    Watch('carciLoginVisible'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LoginTabImpl.prototype, "onCarciLoginVisibleChange", null);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], LoginTabImpl.prototype, "formPasswordRef", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], LoginTabImpl.prototype, "emailRef", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], LoginTabImpl.prototype, "passwordRef", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], LoginTabImpl.prototype, "formSmsRef", void 0);
LoginTabImpl = __decorate([
    Component({
        name: 'LoginTab',
        components: {
            PsInput,
            PtIcon,
            MobileVerifyCodeForm,
            WechatCode,
            EmailVerifyDialog: () => import('../EmailVerifyDialog/EmailVerifyDialog.vue'),
            GoogleLoginButton,
            TermsOfServiceUpdate,
            SSOLogin,
            ElTooltip: Tooltip,
        },
    })
], LoginTabImpl);
export { LoginTabImpl };
